(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-bkp"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  function openFooterLiveChat() {
    const initGorgiasChatPromise = window.GorgiasChat
      ? window.GorgiasChat.init()
      : new Promise(function (resolve) {
          window.addEventListener('gorgias-widget-loaded', function () {
            resolve();
          });
        });

    initGorgiasChatPromise.then(function () {
      if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
        window.GorgiasChat.open();
        return;
      }

      document.querySelector('#chat-button')?.click();
    });
  }

  document.addEventListener('click', function (event) {
    const chatTrigger = event.target.closest('[data-footer-open-chat], #open-live-chat');
    if (!chatTrigger) return;

    event.preventDefault();
    openFooterLiveChat();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-bestsellers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hc-bestsellers')) {
  customElements.define('hc-bestsellers', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.select = this.querySelector('[data-hc-bestsellers-select]');
      if (!this.select) return;
      this.initialized = true;
      this.panels = new Map(Array.from(this.querySelectorAll('[data-hc-bestsellers-panel]'),
        panel => [panel.dataset.hcBestsellersPanel, panel]));
      this.region = this.querySelector('[data-hc-bestsellers-panels]');
      this.status = this.querySelector('[data-hc-bestsellers-status]');
      this.message = this.querySelector('[data-hc-bestsellers-message]');
      this.retry = this.querySelector('[data-hc-bestsellers-retry]');
      this.activeIndex = this.select.value;
      this.select.addEventListener('change', () => this.choose(this.select.value));
      this.retry.addEventListener('click', () => {
        this.select.value = this.retryIndex;
        this.choose(this.retryIndex);
      });
      this.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-hc-bestsellers-panel]');
        if (panel && this.contains(panel)) {
          this.select.value = panel.dataset.hcBestsellersPanel;
          this.choose(this.select.value);
        }
      });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.pending = null;
    }

    show(index) {
      this.panels.forEach((panel, panelIndex) => { panel.hidden = panelIndex !== index; });
      this.activeIndex = index;
      this.region.removeAttribute('aria-busy');
      this.status.hidden = true;
    }

    async fetchPanels() {
      const url = new URL(window.location.href);
      url.hash = '';
      url.searchParams.delete('sections');
      url.searchParams.set('section_id', this.dataset.sectionId);
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 15000);
      try {
        const response = await fetch(url, {
          credentials: 'same-origin',
          headers: { Accept: 'text/html' },
          signal: this.controller.signal
        });
        if (!response.ok) throw new Error('Unable to load product groups');
        const template = document.createElement('template');
        template.innerHTML = await response.text();
        const section = template.content.querySelector('hc-bestsellers');
        if (section?.dataset.sectionId !== this.dataset.sectionId) {
          throw new Error('Product groups response did not match this section');
        }
        const panels = new Map(Array.from(section.querySelectorAll('[data-hc-bestsellers-panel]'),
          panel => [panel.dataset.hcBestsellersPanel, panel]));
        for (const index of this.panels.keys()) {
          if (panels.get(index)?.dataset.hcBestsellersLoaded !== 'true') {
            throw new Error('Product group was not rendered');
          }
        }
        return panels;
      } finally {
        clearTimeout(timeout);
      }
    }

    async choose(index) {
      const panel = this.panels.get(index);
      if (!panel) return;
      const selection = (this.selection || 0) + 1;
      this.selection = selection;
      if (panel.dataset.hcBestsellersLoaded === 'true') {
        this.show(index);
        return;
      }
      this.region.setAttribute('aria-busy', 'true');
      this.message.textContent = this.dataset.loadingMessage;
      this.retry.hidden = true;
      this.status.hidden = false;
      try {
        if (!this.pending) {
          this.pending = this.fetchPanels().catch(error => {
            this.pending = null;
            throw error;
          });
        }
        const panels = await this.pending;
        if (!this.isConnected || this.selection !== selection) return;
        const replacement = panels.get(index).cloneNode(true);
        const scripts = Array.from(replacement.querySelectorAll('script'), script => {
          const marker = document.createElement('template');
          script.replaceWith(marker);
          return { script, marker };
        });
        panel.replaceWith(replacement);
        this.panels.set(index, replacement);
        this.show(index);
        scripts.forEach(({ script, marker }) => {
          const executable = document.createElement('script');
          for (const attribute of script.attributes) {
            executable.setAttribute(attribute.name, attribute.value);
          }
          executable.textContent = script.textContent;
          marker.replaceWith(executable);
        });
      } catch {
        if (!this.isConnected || this.selection !== selection) return;
        this.region.removeAttribute('aria-busy');
        this.message.textContent = this.dataset.errorMessage;
        this.retryIndex = index;
        this.select.value = this.activeIndex;
        this.retry.hidden = false;
        this.status.hidden = false;
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
